module.exports = __webpack_public_path__ + "images/emoji/expressionless.84c13419f4e727202abc.png";